<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.reasons', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-reason' }">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <template v-if="rows">
                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mReasons"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="reasons-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mReasons"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data" v-if="data.item.isAuthor || hasAdminRole">
                            <div class="row" v-if="data.item.isAuthor || hasAdminRole">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-reason', params: { reason: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.reasons', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.reference }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteReason(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="reasons-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import _ from 'lodash';
    
    export default {
        name: "Reasons",
        computed: {
            ...mapGetters(["reasons"]),

            mReasons: function() {
                let pArray = [];

                _.forEach(this.reasons, function(reason) {
                    let p = {};

                    p.reference = reason.reference;
                    p.description = reason.description;
                    p.slug = reason.slug;
                    p.id = reason.id;
                    p.isAuthor = reason.isAuthor;

                    pArray.push(p);
                });

                return pArray;
            },

            rows: function() {
                return this.mReasons.length;
            }
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'reference',
                        label: this.$i18n.t('message.reference'),
                        sortable: true
                    },
                    {
                        key: 'description',
                        label: this.$i18n.t('message.description'),
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getReasons() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getReasons', { args : args });
            },

            formattedDisplay (result) {
                return result.reference;
            },

            itemSelected(item) {
                this.$router.push({ name: 'reason', params: { reason: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'reason', params: { reason: items[0].slug } });
            },

            deleteReason(reason) {
                let self = this;

                let args = {
                    motif: reason
                };

                let successMessage = this.$i18n.t('message.reasonDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteReason', { args, index: reason, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + reason);
                    });
            }
        },

        mounted() {
            // Fetch reason list
            this.getReasons();
        }
    }
</script>

<style scoped>

</style>